import Dashboard from "../../../../pages/platforms/frontdesk/dashboard";
import {
  PreAnalyticalConsumables,
  AnalyticalConsumables,
  PostAnalyticalConsumables,
} from "../../../../pages/platforms/frontdesk/offers/consumables";
import {
  BrowseSupplies,
  SubmittedRequests,
  ToReceiveRequests,
  CompletedRequests,
  CancelledRequests,
} from "../../../../pages/platforms/frontdesk/supplyHub";

import {
  Onboard,
  Tasks,
  Reports,
} from "../../../../pages/platforms/laboratory/diagnostics";

import { Menus, Services } from "../../../../pages/platforms/cashier";
// import Products from "../../../../pages/platforms/frontdesk/market/products";
// import productsGenerics from "../../../../pages/platforms/frontdesk/market/productsGenerics";
// import machines from "../../../../pages/platforms/SuperAdmin/commerce/assets/machines";
// import generics from "../../../../pages/platforms/frontdesk/market/generics";
import mentainance from "../../../../pages/platforms/frontdesk/market/mentainance";

import Sendouts from "../../../../pages/platforms/laboratory/diagnostics/sendouts";
import Stocks from "../../../../pages/platforms/frontdesk/market/stocks";

const frontdesk = [
  {
    name: "Dashboard",
    icon: "tachometer-alt",
    path: "/dashboard",
    title:
      "Displays announcements and system-wide updates for the frontdesk team.",
    component: Dashboard,
  },
  {
    name: "Logistics ",
    path: "/logistics ",
    icon: "cogs",
    title:
      "Manage logistics  – onboarding, task queue, tracking, and sendouts.",
    children: [
      {
        name: "Onboarding",
        path: "/onboarding",
        icon: "tv",
        title: "Register and onboard patients for diagnostic procedures.",
        component: Onboard,
      },
      {
        name: "Delivery",
        path: "/delivery",
        icon: "clipboard-list",
        title: "View and manage pending diagnostic tasks for patients.",
        component: Tasks,
      },
      {
        name: "Distribution",
        path: "/distribution",
        icon: "file-alt",
        title: "Monitor the progress and reports of diagnostics performed.",
        component: Reports,
      },
      {
        name: "Storage",
        path: "/storage",
        icon: "tv",
        title:
          "Monitor, record, and bill sendouts to outsourced diagnostic partners.",
        component: Sendouts,
      },
    ],
  },
  {
    name: "Supply Hub",
    path: "/supply-hub",
    icon: "warehouse",
    title:
      "Centralized platform for requesting clinic supplies handled by procurement.",
    children: [
      {
        name: "Browse Supplies",
        path: "/browse",
        icon: "boxes",
        title: "Browse available items for internal request.",
        component: BrowseSupplies,
      },
      {
        name: "My Requests",
        path: "/requests",
        icon: "tasks",
        title: "Track and manage your submitted supply requests.",
        children: [
          {
            name: "Submitted",
            path: "/submitted",
            icon: "file-invoice",
            title: "Requests that are awaiting procurement action.",
            component: SubmittedRequests,
          },
          {
            name: "To Receive",
            path: "/to-receive",
            icon: "clipboard-list",
            title:
              "Requests that have been approved and are ready for receipt.",
            component: ToReceiveRequests,
          },
          {
            name: "Completed",
            path: "/completed",
            icon: "check-circle",
            title: "Requests that have been successfully received.",
            component: CompletedRequests,
          },
          {
            name: "Cancelled",
            path: "/cancelled",
            icon: "ban",
            title: "Requests that were withdrawn or rejected.",
            component: CancelledRequests,
          },
        ],
      },
    ],
  },
  {
    name: "Merchandise",
    path: "/merchandise",
    icon: "boxes",
    title:
      "Manage inventory and product listings like machines, medicines, and consumables.",
    children: [
      // {
      //   name: "productsGenerics",
      //   path: "/productsGenerics",
      //   icon: "cogs",
      //   title: "List of generic categories for medical products.",
      //   component: productsGenerics,
      // },
      // {
      //   name: "products",
      //   path: "/products",
      //   icon: "cogs",
      //   title: "Inventory of available products for use or sale.",
      //   component: Products,
      // },
      // {
      //   name: "Machines",
      //   path: "/merchandise/machines",
      //   icon: "laptop-code",
      //   title: "List and manage medical machines and diagnostic equipment.",
      //   component: machines, // add your component here
      // },
      // {
      //   name: "Medicines",
      //   path: "/medicines",
      //   icon: "laptop-code",
      //   title: "Manage pharmaceutical stocks and generic drugs.",
      //   component: generics, // add your component here
      // },
      {
        name: "Mentainance",
        path: "/merchandise/mentainance",
        icon: "laptop-code",
        title: "Track machine maintenance and calibration schedules.",
        component: mentainance,
      },
      {
        name: "Stocks",
        path: "/merchandise/stocks",
        icon: "box",
        component: Stocks, // add your component here
      },
    ],
  },
  {
    name: "Catalogs",
    path: "/offers",
    icon: "list",
    children: [
      {
        name: "Menus",
        path: "/offers/menus",
        icon: "bars",
        component: Menus,
      },
      {
        name: "Services",
        path: "/offers/services",
        icon: "list",
        component: Services,
      },
      {
        name: "Consumables",
        icon: "tv",
        path: "/consumables",
        children: [
          {
            name: "Preanalytical",
            path: "/preanalytical",
            icon: "check-circle",
            title: "Supplies used before analysis, per service",
            component: PreAnalyticalConsumables,
          },
          {
            name: "Analytical",
            path: "/analytical",
            icon: "balance-scale",
            title: "Supplies used during analysis, per service",
            component: AnalyticalConsumables,
          },
          {
            name: "Postanalytical",
            path: "/postanalytical",
            icon: "thermometer-half",
            title: "Supplies used after analysis, per service",
            component: PostAnalyticalConsumables,
          },
        ],
      },
    ],
  },
];

export default frontdesk;
